import React from "react";
import Select from 'react-select';

const customStyles = {
  control: (base, state) => ({
    ...base,
    borderColor: state.isFocused ? '#86b7fe' : '#dee2e6',
    boxShadow: state.isFocused ? '0 0 0 0.25rem rgba(13, 110, 253, 0.25)' : null,
    '&:hover': {
      borderColor: state.isFocused ? '#86b7fe' : '#dee2e6'
    }
  }),
  option: (base, state) => ({
    ...base,
    backgroundColor: state.isSelected ? '#0d6efd' : state.isFocused ? '#e9ecef' : null,
    ':active': {
      backgroundColor: state.isSelected ? '#0d6efd' : '#e9ecef'
    }
  })
};

const SearchSelect = ({ 
  data, 
  selectedValue = null, 
  onChange, 
  placeholder = "Select or search a value...",
  isDisabled = false,
  isLoading = false,
  name = "",
  className = "",
  error = null
}) => {
    return (
        <div className={className}>
            <Select
                value={data.find(item => item.value === selectedValue)}
                onChange={(selected) => onChange(selected?.value || null, name)}
                options={data}
                isClearable
                isSearchable
                isDisabled={isDisabled}
                isLoading={isLoading}
                placeholder={placeholder}
                className={`basic-single ${error ? 'is-invalid' : ''}`}
                classNamePrefix="select"
                styles={customStyles}
                noOptionsMessage={() => "No options found"}
                theme={(theme) => ({
                    ...theme,
                    colors: {
                        ...theme.colors,
                        primary: '#0d6efd',
                        primary25: '#e9ecef',
                        primary50: '#e9ecef',
                    },
                })}
            />
            {error && <div className="invalid-feedback">{error}</div>}
        </div>
    );
};

export default SearchSelect;